module.exports = __webpack_public_path__ + "static/media/cialfo-logo-white.e5aee46c.svg";